export const FilterTypes = {
  MULTI_SELECT: 'multiSelect',
  SINGLE_SELECT: 'singleSelect',
  TEXT: 'text',
  DATE_RANGE: 'dateRange',

  //should be extended according to CDS when needed
  // RANGE: 'range',
};

export const DEFAULT_SELECT_OPTIONS = [];

export const DecoratorOptionType = {
  DIVIDER: '__divider__',
};

export const DateTimezoneLabels = {
  LOCAL: 'Local',
  UTC: 'UTC',
};
